import PointAndClickScene from "@/models/PointAndClickScene";
import {
    AminaInNurseStation, AndreasInRoom,
    Aquarium,
    ArtFlamenco,
    BackgroundHallway,
    BackgroundNurseStation,
    BackgroundRecreationRoom,
    BackgroundRoomCarlos,
    BedAssistance,
    Blanket,
    CalenderRip2, CarlosInChair,
    CarlosRoomDoor, CartIsolation,
    CatRobot, ChristienInNurseStation,
    ClockDigitalDate2,
    ClockWallModern,
    ClockWallOld,
    Cup1,
    Cup2, EricaInNurseStation,
    FilingCabinet,
    FlowersGift,
    HallwayDoorRight, JackInHallway,
    MagazineStack, MiningHelmet,
    MiningLamp,
    MoveHitboxLeft,
    MoveHitboxRight,
    NurseStationRoomDoor,
    PaperTowelDispenser,
    PhotoCat,
    PhotoMiners,
    PhotoWedding,
    Plant3,
    Plant3Hallway,
    Plant4, PosterIsolation,
    PosterMenu,
    PosterPlanner,
    Railing, Rollator,
    StickerDoor,
    TableChairs,
    TVRecreationRoom2, Wheelchair
} from "@/assets/data/objects/ZORO-003-objects";
import PointAndClickItem from "@/models/PointAndClickItem";

export const Zoro003FollowupFindRecipientScene = new PointAndClickScene({
    id: 'zoro-003-followup-collect_items',
    type: 'collect_items',
    showPhoneButton: true,
    startInPreviousSceneLocation: true,
    startLocation: 'room-carlos',
    locations: {
        'room-carlos': {
            items: [
                BackgroundRoomCarlos,

                ArtFlamenco,
                
                MiningLamp,
                PhotoCat,
                Plant4,
                ClockDigitalDate2,
                BedAssistance,
                Blanket,
                MiningHelmet,

                new PointAndClickItem({
                    ...CarlosRoomDoor,
                    interactable: true,
                    itemType: 'move',
                    moveLocation: 'hallway',
                    name: 'Ga naar gang',
                    hoverName: 'Ga naar gang',
                }),
                new PointAndClickItem({
                    ...Wheelchair,
                    scale: { x: -1, y: 1 }
                }),

                new PointAndClickItem({
                    ...CarlosInChair,
                    scale: { x: -1, y: 1 },
                    interactable: true,
                    itemType: 'action',
                    hoverType: 'talk',
                    action: 'talk_with_recipient',
                    name: 'Praat met Andreas en Carlos'
                }),
                new PointAndClickItem({
                    ...AndreasInRoom,
                    pos: { left: 202, top: 285 },
                    interactable: true,
                    itemType: 'action',
                    hoverType: 'talk',
                    action: 'talk_with_recipient',
                    name: 'Praat met Andreas en Carlos'
                }),
                PhotoWedding,
                CatRobot,
            ]
        },
        'hallway': {
            items: [
                BackgroundHallway,

                Plant3Hallway,
                PosterPlanner,
                Railing,

                StickerDoor,
                new PointAndClickItem({
                    ...HallwayDoorRight,
                    sound: undefined,
                    interactable: true,
                    itemType: 'move',
                    moveLocation: 'room-carlos',
                    name: 'Ga naar kamer',
                    hoverName: 'Ga naar kamer'
                }),

                PosterMenu,
                PosterIsolation,
                CartIsolation,
                new PointAndClickItem({
                    ...JackInHallway,
                    scale: { x: -1, y: 1 },
                }),

                new PointAndClickItem({
                    ...MoveHitboxLeft,
                    id: 'to-nurse-station',
                    moveLocation: 'nurse-station',
                    name: 'Ga naar verpleegpost',
                    hoverName: 'Ga naar verpleegpost',
                }),
                new PointAndClickItem({
                    ...MoveHitboxRight,
                    id: 'to-recreation-room',
                    moveLocation: 'recreation-room',
                    name: 'Ga naar leefruimte',
                    hoverName: 'Ga naar leefruimte',
                })
            ]
        },
        'nurse-station': {
            items: [
                BackgroundNurseStation,

                Cup1,
                Cup2,
                FlowersGift,
                FilingCabinet,


                new PointAndClickItem({
                    ...NurseStationRoomDoor,
                    interactable: true,
                    itemType: 'move',
                    moveLocation: 'hallway',
                    name: 'Ga naar gang',
                    hoverName: 'Ga naar gang'
                }),

                ClockWallModern,
                PaperTowelDispenser,

                new PointAndClickItem({
                    ...AminaInNurseStation,
                    pos: { left: 209, top: 314 },
                }),

                new PointAndClickItem({
                    ...EricaInNurseStation,
                    pos: { left: 452, top: 314 },
                }),

                new PointAndClickItem({
                    ...ChristienInNurseStation,
                    pos: { left: 656, top: 314 },
                }),
            ]
        },
        'recreation-room': {
            items: [
                BackgroundRecreationRoom,

                Plant3,
                TVRecreationRoom2,
                TableChairs,
                new PointAndClickItem({
                    ...Rollator,
                    pos: { left: 266 - 180 - 350 / 2, top: 1021 - 180 - 315 / 2 }
                }),
                PhotoMiners,
                Aquarium,

                ClockWallOld,
                CalenderRip2,
                MagazineStack,

                new PointAndClickItem({
                    ...MoveHitboxLeft,
                    id: 'to-hallway',
                    moveLocation: 'hallway',
                    name: 'Ga naar gang',
                    hoverName: 'Ga naar gang',
                })
            ]
        }
    }
});